import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListSubheader, makeStyles } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { COLORS } from './logsConstants';

const useStyles = makeStyles(() => ({
  icon: {
    padding: 3,
    marginLeft: 4,
    color: COLORS.accent,
    verticalAlign: 'middle',
  },
  heading: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '.03em',
    color: COLORS.textMuted,
    lineHeight: '28px',
  },
  itemDesc: {
    fontSize: 13,
    color: COLORS.textPrimary,
  },
}));


export default function LogLinkMenu({ heading, items, onSelect }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  if (!items || items.length === 0) return null;

  if (!Array.isArray(items)) {
    return (
      <IconButton
        size="small"
        className={classes.icon}
        onClick={(e) => onSelect(e, items)}
      >
        <OpenInNewIcon style={{ fontSize: 14 }} />
      </IconButton>
    );
  }

  return (
    <>
      <IconButton
        size="small"
        className={classes.icon}
        aria-label={heading}
        onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(e.currentTarget)
        }}
      >
        <OpenInNewIcon style={{ fontSize: 14 }} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <ListSubheader className={classes.heading}>{heading}</ListSubheader>
        {items.map((item, i) => (
          <MenuItem
            key={i}
            className={classes.itemDesc}
            onClick={(e) => {
              setAnchorEl(null);
              onSelect(e, item.link);
            }}
          >
            {item.desc}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}